import Uttalelse from "./Uttalelse";

export default Uttalelse;
